import { ChangeDetectionStrategy, Component, input } from '@angular/core'
import { MixingEvent } from 'projects/commons/src/lib/types/mixing'

@Component({
  standalone: true,
  selector: 'cyc-mixing-dots',
  templateUrl: './mixing-dots.component.html',
  styleUrls: ['./mixing-dots.component.scss'],
  imports: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MixingDotsComponent {
  mixingEvent = input<MixingEvent>()

  public log() {
    const mixingEvent = this.mixingEvent()
    if (mixingEvent) {
      console.group('Mixing Event')
      console.log('status', mixingEvent.status)
      console.log('lastUpdateTimestamp', mixingEvent.lastUpdateTimestamp)
      console.log('currentStageIndex', mixingEvent.currentStageIndex)
      console.log('speedPattern')
      console.table(mixingEvent.speedPattern)
      console.groupEnd()
    }
  }
}
